<template>
  <div class="c-macros">
    <div class="macro-list" v-if="false">
      <div
        class="macro-item"
        v-for="i in 18"
        :key="i"
        :class="{ active: i === 1 }"
      >
        MACRO {{ i }}
      </div>
    </div>
    <a-mentions class="macro" prefix="{" split="">
      <a-mentions-option value="AM_ESC}">
        AM_ESC
      </a-mentions-option>
    </a-mentions>
  </div>
</template>
<script>
export default {
  name: "CMacros",
  props: {
    liked: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    init() {},
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss">
.c-macros {
  width: 100%;
  height: 400px;
  display: flex;
  margin-bottom: 30px;

  .macro-list {
    width: 150px;
    height: 100%;
    margin-right: 10px;
    flex: none;
    border: 1px solid #762eec;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow-x: hidden;
    overflow-y: scroll;
    padding: 10px 15px;

    .macro-item {
      padding-left: 15px;
      font-size: 16px;
      color: #515151;
      position: relative;
      cursor: pointer;

      &:hover {
        color: #ffffff;
      }

      &.active {
        color: #ffffff;

        &::before {
          display: block;
          content: " ";
          width: 3px;
          height: 12px;
          background: #ffffff;
          border-radius: 5px;
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -6px;
        }
      }
    }
  }

  .macro {
    width: 50%;
    height: 100%;
    flex: auto;
    border: 1px solid #762eec;
    border-radius: 5px;
    background: transparent;
    text-align: left;

    textarea {
      height: 100%;
      color: #ffffff;
      font-size: 18px;
    }
  }
}
</style>
